import { render, staticRenderFns } from "./AlertRSHistoryTable.vue?vue&type=template&id=28387c36&scoped=true&"
import script from "./AlertRSHistoryTable.vue?vue&type=script&lang=js&"
export * from "./AlertRSHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./AlertRSHistoryTable.vue?vue&type=style&index=0&id=28387c36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28387c36",
  null
  
)

export default component.exports